import React, { useEffect, useState, useCallback } from "react";
import {
    getClassroomsForSchool,
    getStudentsForClassroom,
    approveStudent,
    getPendingStudents,
    addClassroom,
    approveTeacherAndMigrate,
    fetchSchools,
    getPendingTeachersFromUsers,
    getTeachersForSchool,

} from "../services/firestoreService";
import "./Dashboard.css";
import { setDoc, doc, Timestamp } from "firebase/firestore";
import { db } from "../services/firebase"; // adjust ikut path kamu

import { surahData } from "../data/surahData";
import StudentDetails from "./StudentDetails";
import LoadingScreen from "../components/LoadingScreen";
import SchoolDropdown from "../components/SchoolDropdown";
import { getInitials, generateUserId } from "../utils/commonUtils";
import { toast } from "react-toastify";
import { FiPlus, FiX } from "react-icons/fi";
import { useNavigate } from "react-router-dom";






const TeacherDashboard = ({ setNavbarVisibility }) => {
    const [isLoading, setIsLoading] = useState(true); // Add a loading state
    const navigate = useNavigate();

    const [selectedSchool, setSelectedSchool] = useState(null);
    const [classrooms, setClassrooms] = useState([]);
    const [selectedClassroom, setSelectedClassroom] = useState(null);
    const [students, setStudents] = useState([]);
    const [pendingStudents, setPendingStudents] = useState([]);
    const [pendingTeachers, setPendingTeachers] = useState([]);
    const [newClassName, setNewClassName] = useState("");
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [isFormMuridVisible, setIsFormMuridVisible] = useState(false);
    const [approvedTeachers, setApprovedTeachers] = useState([]);

    const [selectedStudent, setSelectedStudent] = useState(null);

    const [mappedSchools, setMappedSchools] = useState([]);

    const [user, setUser] = useState(null);
    const [adminSchools, setAdminSchools] = useState([]);
    const [newStudentName, setNewStudentName] = useState("");
    const [dragStartY, setDragStartY] = useState(null);
    const [dragTranslateY, setDragTranslateY] = useState(0);

    const handleDrawerTouchStart = (e) => {
        if (e.touches.length !== 1) return;
        setDragStartY(e.touches[0].clientY);
    };

    const handleDrawerTouchMove = (e) => {
        if (dragStartY === null) return;
        const currentY = e.touches[0].clientY;
        const deltaY = currentY - dragStartY;

        // hanya kira bila drag ke bawah
        if (deltaY > 0) {
            e.preventDefault(); // block scroll page belakang
            setDragTranslateY(deltaY);
        }
    };

    const handleDrawerTouchEnd = () => {
        const threshold = 120; // jarak drag untuk trigger close
        if (dragTranslateY > threshold) {
            setSelectedStudent(null);
        }
        setDragStartY(null);
        setDragTranslateY(0);
    };


    useEffect(() => {
        if (selectedStudent) {
            // lock scroll body
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [selectedStudent]);

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem("user"));
        setUser(stored);

        if (stored?.role === "teacher" && Array.isArray(stored.schools)) {
            const approved = stored.schools.filter(s => s.isApproved);
            setAdminSchools(approved.filter(s => s.isAdmin));
        }
    }, []);

    useEffect(() => {
        if (classrooms.length > 0 && !selectedClassroom) {
            const firstClass = classrooms[0];
            setSelectedClassroom(firstClass.id);
        }
    }, [classrooms, selectedClassroom]);


    const toggleFormVisibility = () => setIsFormVisible((prev) => !prev);
    const toggleFormMuridVisibility = () => setIsFormMuridVisible((prev) => !prev);


    const fetchClassrooms = useCallback(
        async (schoolId) => {
            try {
                const data = await getClassroomsForSchool(schoolId);

                const filteredClassrooms = adminSchools.some(
                    (school) => school.schoolId === schoolId
                )
                    ? data
                    : data.filter(
                        (classroom) =>
                            classroom.teacherId === user.id ||
                            (classroom.teachers || []).includes(user.id)
                    );

                setClassrooms(filteredClassrooms);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching classrooms:", error);
                toast.error("Failed to fetch classrooms.");
            }
        },
        [adminSchools, user] // dependencies untuk function ni
    );


    // Fetch schools and map them with names
    useEffect(() => {
        const fetchAndMapSchools = async () => {
            if (!user?.schools) return;

            try {
                const allSchools = await fetchSchools();
                const updatedSchools = user.schools.map((userSchool) => {
                    const schoolDetails = allSchools.find((s) => s.id === userSchool.schoolId);
                    return {
                        ...userSchool,
                        name: schoolDetails?.name || "Unknown School",
                        secretCode: schoolDetails?.secretCode || "",
                    };
                });

                setMappedSchools(updatedSchools);

                if (updatedSchools.length > 0 && !selectedSchool) {
                    const firstSchool = updatedSchools.find((school) => school.isApproved);
                    if (firstSchool) {
                        setSelectedSchool(firstSchool);

                    }
                }
            } catch (error) {
                console.error("Error mapping schools:", error);
            }
        };

        fetchAndMapSchools();
    }, [selectedSchool, user]);

    useEffect(() => {
        if (!user || !selectedSchool) return;
        fetchClassrooms(selectedSchool.schoolId);
    }, [user, selectedSchool, fetchClassrooms]);

    useEffect(() => {
        const fetchPendingTeachers = async () => {
            if (!selectedSchool || !adminSchools.some((school) => school.schoolId === selectedSchool.schoolId)) return;

            try {
                const data = await getPendingTeachersFromUsers(selectedSchool.schoolId);
                setPendingTeachers(data);
            } catch (error) {
                console.error("Error fetching pending teachers:", error);
                toast.error("Failed to fetch pending teachers.");
            }
        };

        fetchPendingTeachers();
    }, [selectedSchool, adminSchools]);

    useEffect(() => {
        const fetchApprovedTeachers = async () => {
            if (!selectedSchool) return;

            try {
                const teachers = await getTeachersForSchool(selectedSchool.schoolId);
                setApprovedTeachers(teachers);
            } catch (error) {
                console.error("Error fetching approved teachers:", error);
            }
        };

        fetchApprovedTeachers();
    }, [selectedSchool]);

    useEffect(() => {
        if (!selectedClassroom || !selectedSchool?.schoolId) return;

        const fetchStudents = async () => {
            try {

                const pending = await getPendingStudents(selectedClassroom, selectedSchool.schoolId);
                const approved = await getStudentsForClassroom(selectedClassroom);

                const filteredApproved = approved.filter((student) =>
                    student.classroomApprovals?.some(
                        (approval) => approval.classroomId === selectedClassroom && approval.isApproved
                    )
                );

                setPendingStudents(pending);
                setStudents(filteredApproved);

            } catch (error) {
                console.error("Error fetching students:", error);
                toast.error("Failed to fetch students.");
            }
        };


        fetchStudents();
    }, [selectedClassroom, selectedSchool]);





    // Handlers
    const handleSelectSchool = (school) => {
        setSelectedSchool(school);

        setClassrooms([]);
        setSelectedClassroom(null);
        setStudents([]);
        setPendingStudents([]);
        setPendingTeachers([]);
    };

    const handleCreateClassroom = async (e) => {
        e.preventDefault();
        if (!newClassName.trim() || !selectedSchool) {
            toast.warn("Please provide a classroom name and select a school.");
            return;
        }

        try {
            await addClassroom(newClassName, selectedSchool.schoolId, user.id);
            setNewClassName("");
            toast.success(`Classroom "${newClassName}" created successfully!`);
            fetchClassrooms(selectedSchool.schoolId); // Refresh classrooms
        } catch (error) {
            console.error("Error creating classroom:", error);
            toast.error("Error creating classroom. Please try again.");
        }
    };

    const handleStudentClick = (student) => {
        console.log("Student clicked:", student); // Ensure the student data is complete
        console.log("Student data passed to StudentDetails:", student);

        let currentSurahIndex = 0;
        let startAyah = 1;

        if (student.progress?.length > 0) {
            const lastProgress = student.progress[student.progress.length - 1];
            const surah = surahData.find((s) => s.name === lastProgress.surah);

            if (surah) {
                const nextAyah = lastProgress.endAyah + 1;
                if (nextAyah > surah.totalAyahs) {
                    currentSurahIndex = surahData.indexOf(surah) + 1;
                    startAyah = 1;
                } else {
                    currentSurahIndex = surahData.indexOf(surah);
                    startAyah = nextAyah;
                }
            }
        }

        // Pass all necessary data to `StudentDetails`
        setSelectedStudent({
            ...student,
            schoolId: selectedSchool?.schoolId || "Unknown School",
            classroomId: selectedClassroom || "Unknown Classroom",
            currentSurahIndex,
            startAyah,
        });
    };

    const handleApproveTeacher = async (teacherId) => {
        try {
            await approveTeacherAndMigrate(teacherId, selectedSchool.schoolId);
            setPendingTeachers((prev) => prev.filter((teacher) => teacher.id !== teacherId));
            toast.success("Guru berjaya diluluskan dan dimigrasi.");
        } catch (error) {
            console.error("Error approving teacher:", error);
            toast.error("Gagal meluluskan guru.");
        }
    };

    const handleSelectClassroom = (classroomId) => {
        console.log("Selected Classroom:", classroomId);
        setSelectedClassroom(classroomId);
    };

    const handleApproveStudent = async (studentId) => {
        try {
            await approveStudent(studentId, selectedClassroom, selectedSchool.schoolId);

            // Cari pelajar yang baru diluluskan
            const approvedStudent = pendingStudents.find((student) => student.id === studentId);

            if (approvedStudent) {
                // Kemaskini UI:
                setPendingStudents((prev) => prev.filter((s) => s.id !== studentId));
                setStudents((prev) => [
                    ...prev,
                    {
                        ...approvedStudent,
                        classroomApprovals: [{ classroomId: selectedClassroom, isApproved: true }],
                    },
                ]);
            }
        } catch (error) {
            console.error("Error approving student:", error);
            toast.error("Failed to approve student.");
        }
    };

    const handleManualStudentAdd = async (e) => {
        e.preventDefault();
        if (!newStudentName.trim()) {
            toast.warn("Sila masukkan nama murid.");
            return;
        }

        try {
            const studentId = generateUserId("student", newStudentName);
            const newStudent = {
                id: studentId,
                name: newStudentName,
                role: "student",
                schoolId: selectedSchool.schoolId,
                classroomId: selectedClassroom,
                email: "",
                avatar: null,
                isManualEntry: true,
                isApproved: true,
                createdBy: user.id,
                createdAt: Timestamp.now(),
                progress: [],
                classroomApprovals: [
                    {
                        classroomId: selectedClassroom,
                        isApproved: true,
                    },
                ],
            };

            await setDoc(doc(db, "students", studentId), newStudent);
            setStudents((prev) => [...prev, newStudent]);
            setNewStudentName("");
            toast.success(`Murid ${newStudentName} berjaya ditambah.`);
        } catch (error) {
            console.error("Gagal tambah murid manual:", error);
            toast.error("Ralat semasa menambah murid.");
        }
    };



    // Get the selected classroom's name
    const getSelectedClassroomName = () => {
        const selected = classrooms.find((classroom) => classroom.id === selectedClassroom);
        return selected ? selected.name : "Unknown";
    };




    useEffect(() => {
        if (selectedStudent) {
            console.log("Selected Student Details:", selectedStudent);
        }
    }, [selectedStudent]);



    if (isLoading) {
        return <LoadingScreen />;
    }

    return (
        <div className="dashboard-container">
            <div className="dashboard-content">

                <SchoolDropdown
                    schools={mappedSchools}
                    selectedSchool={selectedSchool}
                    onSelect={handleSelectSchool}
                />

                {/* Classrooms Section */}
                {selectedSchool && (
                    <div className="dashboard-section-school">
                        {adminSchools.some((school) => school.schoolId === selectedSchool.schoolId) &&
                            pendingTeachers.length > 0 && (
                                <div >

                                    <span className="menu-dashboard-title" >Permintaan menjadi guru tasmik</span >

                                    <ul>
                                        {pendingTeachers.map((teacher) => (
                                            <li key={teacher.id}>
                                                {teacher.name} ({teacher.email})
                                                <button onClick={() => handleApproveTeacher(teacher.id)}>Benarkan</button>
                                            </li>
                                        ))}
                                    </ul>
                                    <hr />

                                </div>
                            )}



                        <div className="teacher-avatar-list">
                            <span >Senarai <br />Guru</span>

                            {approvedTeachers.map((teacher) => (

                                <div
                                    className="teacher-avatar-item"
                                    key={teacher.id}
                                    onClick={() => navigate("/teacher/detail", { state: { teacher } })}
                                    style={{ cursor: "pointer" }}
                                >
                                    {teacher.avatar ? (
                                        <img
                                            src={teacher.avatar}
                                            alt="Teacher Avatar"
                                            className="teacher-avatar-circle"
                                        />
                                    ) : (
                                        <div className="teacher-avatar-circle initials-avatar">
                                            {getInitials(teacher.name)}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="line-separator"></div>
                        <div className="kelas-tasmik-header">
                            <span className="menu-dashboard-title" >Kelas Tasmik</span >

                            <div className="toggle-icon" onClick={toggleFormVisibility}>
                                {isFormVisible ? (
                                    <>
                                        <FiX className="icon-button" />
                                        Tutup
                                    </>
                                ) : (
                                    <>
                                        <FiPlus className="icon-button" />
                                        Tambah
                                    </>
                                )}
                            </div>

                        </div>

                        {isFormVisible && (
                            <form onSubmit={handleCreateClassroom} className="classroom-form">
                                <input
                                    type="text"
                                    placeholder="Masukkan nama kelas"
                                    value={newClassName}
                                    onChange={(e) => setNewClassName(e.target.value)}
                                    className="classroom-input"
                                />
                                <button type="submit" className="create-button">
                                    Cipta
                                </button>
                            </form>
                        )}


                        {classrooms.length === 0 ? (
                            <div className="no-students-container">
                                <img
                                    src={`${process.env.PUBLIC_URL}/assets/class.png`}
                                    alt="No Students"
                                    className="no-students-image"
                                />
                                <p className="no-students-message">Sila cipta kelas tasmik<br />pertama anda</p>
                            </div>
                        ) : (
                            <div className="school-box-scroll-container">
                                {classrooms.map((classroom) => {

                                    return (
                                        <div
                                            key={classroom.id}
                                            className={`class-box ${selectedClassroom === classroom.id ? "active" : ""}`}
                                            onClick={() => handleSelectClassroom(classroom.id)}
                                        >
                                            <h3 className="classroom-name">{classroom.name}</h3>

                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <span style={{ fontSize: "12px", marginRight: "5px" }}>Guru</span>

                                                <div style={{ display: "flex", gap: "0px" }}>
                                                    {(classroom.teachers || []).map((teacherId) => {
                                                        const teacher = approvedTeachers.find(t => t.id === teacherId);
                                                        if (!teacher) return null;

                                                        return teacher.avatar ? (
                                                            <img
                                                                key={teacher.id}
                                                                src={teacher.avatar}
                                                                alt={`${teacher.name}'s Avatar`}
                                                                className="teacher-avatar"
                                                            />
                                                        ) : (
                                                            <div key={teacher.id} className="teacher-avatar initials-avatar">
                                                                {getInitials(teacher.name)}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                            </div>
                        )}
                    </div>
                )}


                {pendingStudents.length > 0 && (
                    <div className="pending-container">
                        <span className="menu-dashboard-title" >Permohonan Masuk Kelas</span >

                        <ul>
                            {pendingStudents.map((student) => (
                                <li key={student.id}>
                                    <span style={{ textAlign: "start", fontSize: "15px" }}>{student.name}</span>
                                    <button onClick={() => handleApproveStudent(student.id)}>Benarkan</button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}



                {selectedStudent ? (
                    <div
                        className={`student-details-wrapper ${selectedStudent ? "open" : ""}`}
                        onClick={() => setSelectedStudent(null)} // tap luar tutup
                    >
                        <div
                            className={`student-details-drawer ${selectedStudent ? "open" : ""}`}
                            onClick={(e) => e.stopPropagation()} // jangan tutup bila klik dalam
                            onTouchStart={handleDrawerTouchStart}
                            onTouchMove={handleDrawerTouchMove}
                            onTouchEnd={handleDrawerTouchEnd}
                            style={{
                                transform: `translateY(${dragTranslateY}px)`,
                                transition: dragStartY ? "none" : "transform 0.25s ease-out",
                            }}
                        >
                            <StudentDetails
                                student={selectedStudent}
                                onBack={(updatedStudent) => {
                                    setSelectedStudent(null);
                                    setStudents((prevStudents) =>
                                        prevStudents.map((student) =>
                                            student.id === updatedStudent.id ? updatedStudent : student
                                        )
                                    );
                                }}
                                onUpdate={(updatedStudent) => {
                                    setStudents((prevStudents) =>
                                        prevStudents.map((s) =>
                                            s.id === updatedStudent.id ? updatedStudent : s
                                        )
                                    );
                                }}
                            />
                        </div>
                    </div>
                ) : (
                    // Render student list if no student is selected
                    selectedClassroom && (
                        <div className="dashboard-section">
                            <div className="kelas-tasmik-header">
                                <span className="menu-dashboard-title" >Murid {getSelectedClassroomName()}</span >
                                <div className="toggle-icon" onClick={toggleFormMuridVisibility}>
                                    {isFormMuridVisible ? (
                                        <>
                                            <FiX className="icon-button" />
                                            Tutup
                                        </>
                                    ) : (
                                        <>
                                            <FiPlus className="icon-button" />
                                            Tambah
                                        </>
                                    )}
                                </div>
                            </div>
                            {isFormMuridVisible && (
                                <form onSubmit={handleManualStudentAdd} className="classroom-form">
                                    <input
                                        type="text"
                                        placeholder="Masukkan nama murid"
                                        value={newStudentName}
                                        onChange={(e) => setNewStudentName(e.target.value)}
                                        className="classroom-input"
                                    />
                                    <button type="submit" className="create-button">
                                        Cipta
                                    </button>
                                </form>
                            )}


                            <div className="students-list">
                                {students.length > 0 ? (
                                    students.map((student) => (
                                        <div
                                            key={student.id}
                                            className="student-container"
                                            onClick={() => handleStudentClick(student)} // Use the handleStudentClick function
                                        >
                                            <div className="student-title">
                                                {student.avatar ? (
                                                    <img
                                                        src={student.avatar}
                                                        alt="Student Avatar"
                                                        className="student-avatar"
                                                    />
                                                ) : (
                                                    <div className="student-avatar initials-avatar">
                                                        {getInitials(student.name)}
                                                    </div>
                                                )}

                                                <div className="student-details">
                                                    {student.name}

                                                </div>
                                            </div>
                                            <div className="student-title-2">
                                                <div className="juz-badge-dashboard">
                                                    {student.progress?.length > 0
                                                        ? `Juz ${surahData.find(
                                                            (s) => s.name === student.progress.at(-1).surah
                                                        )?.juz.find(
                                                            (j) =>
                                                                student.progress.at(-1).endAyah >= j.startAyah &&
                                                                student.progress.at(-1).endAyah <= j.endAyah
                                                        )?.number || "Unknown"
                                                        }`
                                                        : "Juz 1"}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="no-students-container">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/assets/empty-folder.png`}
                                            alt="No Students"
                                            className="no-students-image"
                                        />
                                        <p className="no-students-message">Tiada murid</p>
                                    </div>
                                )}

                            </div>

                        </div>
                    )
                )}


            </div>


        </div>
    );
};

export default TeacherDashboard;
